import { useAuth } from '../context/AuthContext';
import { translations } from '../i18n/translations';

export const useTranslation = () => {
  const { language } = useAuth();
  
  const t = (key) => {
    return translations[language]?.[key] || translations.de[key] || key;
  };
  
  return { t, language };
};
